import { ServiceBase } from './ServiceBase';

export class Shifts extends ServiceBase {

}
